import Vue from "vue";
import Api from "../../services/Api";

/** localStorage key backing the nav drawer mini-variant toggle. */
const DRAWER_MINI_STORAGE_KEY = "es_drawer_mini";

/**
 * Reads the persisted mini-variant state so a page load/new tab starts
 * with whatever the user last chose, instead of always defaulting open.
 * @returns {boolean}
 */
function readDrawerMini() {
    return localStorage.getItem(DRAWER_MINI_STORAGE_KEY) === "1";
}

const app = {
    namespaced: true,
    state: {
        showDrawer: true,
        drawerMini: readDrawerMini(),
        next_months: {
            data: [],
            loading: false,
            error: null
        },
        units: {
            data: [],
            loading: false,
            error: null
        },
        tasks: {},
        stockMovementTypes: {
            data: [],
            loading: false,
            error: null
        },
        dailyServiceFormTemplateTypes: {
            data: [],
            loading: false,
            error: null
        },
        taskTemplateTypes: {
            data: [
                {
                    id: 1,
                    description: "start_date"
                },
                {
                    id: 2,
                    description: "end_date"
                },
                {
                    id: 3,
                    description: "process_start_date"
                },
                {
                    id: 4,
                    description: "process_end_date"
                }
            ],
            loading: false,
            error: null
        },
        serviceFormFrequencies: {
            data: [
                {
                    id: -1,
                    description: "manual"
                },
                {
                    id: 0,
                    description: "single_time"
                },
                {
                    id: 1,
                    description: "every_day"
                },
                {
                    id: 7,
                    description: "every_week"
                },
                {
                    id: 30,
                    description: "every_month"
                },
                {
                    id: 99,
                    description: "on_creation"
                }
            ],
            loading: false,
            error: null
        },
        vacationTypes: {
            data: [
                {
                    id: 1,
                    description: "vacation"
                },
                {
                    id: 2,
                    description: "missed"
                },
                {
                    id: 3,
                    description: "sick_leave"
                },
                {
                    id: 4,
                    description: "insurance"
                },
                {
                    id: 5,
                    description: "company_vacation"
                },
                {
                    id: 6,
                    description: "parental_leave"
                },
                {
                    id: 7,
                    description: "mourning"
                },
                {
                    id: 8,
                    description: "marriage"
                }
            ],
            loading: false,
            error: null
        },
        weekDays: {
            data: [
                {
                    id: 1,
                    description: "sunday"
                },
                {
                    id: 2,
                    description: "monday"
                },
                {
                    id: 3,
                    description: "tuesday"
                },
                {
                    id: 4,
                    description: "wednesday"
                },
                {
                    id: 5,
                    description: "thursday"
                },
                {
                    id: 6,
                    description: "friday"
                },
                {
                    id: 7,
                    description: "saturday"
                }
            ],
            loading: false,
            error: null
        },
        colors: {
            data: [
                { value: "blue", hex: "#2196F3" },
                { value: "green", hex: "#4CAF50" },
                { value: "purple", hex: "#9C27B0" },
                { value: "orange", hex: "#FF9800" },
                { value: "rose", hex: "#E91E63" }
            ],
            loading: false,
            error: null
        },
        bookingTypes: {
            data: [
                { value: "daily", description: "daily" },
                { value: "weekly", description: "weekly" },
                { value: "monthly", description: "monthly" },
                { value: "yearly", description: "yearly" }
            ],
            loading: false,
            error: null
        },
        operators: {
            data: [
                { text: "equal", value: "=" },
                { text: "not_equal", value: "!=" },
                { text: "greater_than", value: ">" },
                { text: "less_than", value: "<" },
                { text: "greater_or_equal", value: ">=" },
                { text: "less_or_equal", value: "<=" },
                { text: "contains", value: "contains" },
                { text: "not_contains", value: "not_contains" },
                { text: "starts_with", value: "starts_with" },
                { text: "ends_with", value: "ends_with" },
                { text: "is_empty", value: "is_empty" },
                { text: "is_not_empty", value: "is_not_empty" }
            ],
            loading: false,
            error: null
        },
        absenceClassifications: {
            data: [
                {
                    id: 1,
                    description: "justified_paid"
                },
                {
                    id: 2,
                    description: "justified_unpaid"
                },
                {
                    id: 3,
                    description: "unjustified"
                }
            ],
            loading: false,
            error: null
        },
        resourceTypes: {
            data: [
                {
                    id: "PRC",
                    description: "process"
                },
                {
                    id: "VEH",
                    description: "vehicle"
                },
                {
                    id: "EMP",
                    description: "employee"
                },
                {
                    id: "EQP",
                    description: "equipamento"
                },
                {
                    id: "DEP",
                    description: "departamento"
                }
            ],
            loading: false,
            error: null
        },
        actions: {
            data: [{ id: "created" }, { id: "updated" }, { id: "deleted" }]
        },
        serviceFormAvailabilities: {
            data: [
                {
                    id: 0,
                    description: "beginning"
                },
                {
                    id: 99,
                    description: "date"
                },
                {
                    id: 101,
                    description: "end"
                }
            ],
            loading: false,
            error: null
        },
        serviceFormControls: {
            data: [],
            loading: false,
            error: null
        },
        countries: {
            data: [],
            loading: false,
            error: null
        },
        currencies: {
            data: [],
            loading: false,
            error: null
        },
        companies: {
            data: [],
            loading: false,
            error: null
        },
        expense_types: {
            data: [],
            loading: false,
            error: null
        },
        blood_types: {
            data: [],
            loading: false,
            error: null
        },
        it_equipment_event_types: {
            data: [],
            loading: false,
            error: null
        },
        it_equipment_accessory_types: {
            data: [],
            loading: false,
            error: null
        },
        it_equipment_infos: {
            data: [],
            loading: false,
            error: null
        },
        professional_developments_entities: {
            data: [],
            loading: false,
            error: null
        },
        doctors: {
            data: [],
            loading: false,
            error: null
        },
        vehicle_insurance_entities: {
            data: [],
            loading: false,
            error: null
        },
        safety_next_appointment_months: {
            data: [],
            loading: false,
            error: null
        },
        departments: {},
        serviceFormTypes: {},
        products: {},
        cost_centers: {},
        products_to: null,
        charge_types: {},
        suppliers: {},
        access_levels: [],
        employees: {},
        vehicles: {},
        vehicle_license_types: {},
        vehicle_insurance_types: {},
        frequency_types: {
            data: [],
            loading: false,
            error: null
        },
        equipments: {},
        pv10_countries: {
            data: [],
            loading: false,
            error: null
        },
        pv10_currencies: {
            data: [],
            loading: false,
            error: null
        },
        ivas: {},
        movementTypes: {
            data: [
                {
                    id: 1,
                    description: "stock_movement"
                },
                {
                    id: 2,
                    description: "stock_buy"
                },
                {
                    id: 3,
                    description: "stock_sell"
                },
                {
                    id: 4,
                    description: "stock_discarded"
                },
                {
                    id: 5,
                    description: "stock_in_rent"
                },
                {
                    id: 6,
                    description: "stock_out_rent"
                }
            ],
            loading: false,
            error: null
        }
    },
    mutations: {
        setDrawer: (state, value) => {
            state.showDrawer = value;
        },
        /**
         * Sets mini-variant state and mirrors it to localStorage so the
         * choice survives tab reloads, new tabs, and browser restarts.
         */
        setDrawerMini: (state, value) => {
            state.drawerMini = value;
            localStorage.setItem(DRAWER_MINI_STORAGE_KEY, value ? "1" : "0");
        },
        setError: (state, payload) => {
            if (payload.company) {
                if (state[payload.obj][payload.company] == undefined) {
                    const obj = {};
                    obj[company] = {
                        data: [],
                        loading: false,
                        error: null
                    };
                    state[payload.obj] = Object.assign(
                        {},
                        state[payload.obj],
                        obj
                    );
                }
                state[payload.obj][payload.company].error = payload.value;
            } else {
                state[payload.obj].error = payload.value;
            }
        }
    },
    getters: {
        drawerStatus: (state, _, rootState) => {
            return state.showDrawer && rootState.auth;
        },
        drawerMini: state => {
            return state.drawerMini;
        },
        loading: state => (obj, company) => {
            if (company) {
                if (state[obj][company] == undefined) {
                    const obj = {};
                    obj[company] = {
                        data: [],
                        loading: false,
                        error: null
                    };
                    state[obj] = Object.assign({}, state[obj], obj);
                }
                return state[obj][company].loading;
            } else {
                return state[obj].loading;
            }
        },
        getError: state => (obj, company) => {
            if (company) {
                if (state[obj][company] == undefined) {
                    const obj = {};
                    obj[company] = {
                        data: [],
                        loading: false,
                        error: null
                    };
                    state[obj] = Object.assign({}, state[obj], obj);
                }
                return state[obj][company].error;
            } else {
                return state[obj].error;
            }
        },
        getItems: state => (obj, company, item) => {
            if (company) {
                if (state[obj][company] == undefined) {
                    const val = {};
                    val[company] = {
                        data: [],
                        loading: false,
                        error: null
                    };
                    state[obj] = Object.assign({}, state[obj], val);
                }
                if (item) {
                    return state[obj][company].data[item];
                } else {
                    return state[obj][company].data;
                }
            } else {
                return state[obj].data;
            }
        },
        access_levels: state => {
            return state.access_levels;
        }
    },
    actions: {
        setDrawer: context => {
            context.commit(
                "setDrawer",
                !(context.rootState.auth && context.state.showDrawer)
            );
        },
        toggleDrawerMini: context => {
            context.commit("setDrawerMini", !context.state.drawerMini);
        },
        next_months: context => {
            if (
                !context.state.next_months.loading &&
                context.state.next_months.data.length < 1
            ) {
                context.state.next_months.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/next-month")
                        .then(response => {
                            context.state.next_months.data = response.data;
                            context.state.next_months.loading = false;
                            resolve(context.state.next_months.data);
                        })
                        .catch(error => {
                            context.state.next_months.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.next_months.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.next_months.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        units: context => {
            if (
                !context.state.units.loading &&
                context.state.units.data.length < 1
            ) {
                context.state.units.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/unit")
                        .then(response => {
                            context.state.units.data = response.data;
                            context.state.units.loading = false;
                            resolve(context.state.units.data);
                        })
                        .catch(error => {
                            context.state.units.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.units.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.units.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        tasks: (context, company) => {
            if (context.state.tasks[company] == undefined) {
                const obj = {};
                obj[company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.tasks = Object.assign(
                    {},
                    context.state.tasks,
                    obj
                );
            }
            if (
                !context.state.tasks[company].loading &&
                context.state.tasks[company].data.length < 1
            ) {
                context.state.tasks[company].loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/" + company + "/sys/task")
                        .then(response => {
                            context.state.tasks[company].data = response.data;
                            context.state.tasks[company].loading = false;
                            resolve(context.state.tasks[company].data);
                        })
                        .catch(error => {
                            context.state.tasks[company].error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.tasks[company].loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.tasks[company].data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        dailyServiceFormTemplateTypes: context => {
            if (
                !context.state.dailyServiceFormTemplateTypes.loading &&
                context.state.dailyServiceFormTemplateTypes.data.length < 1
            ) {
                context.state.dailyServiceFormTemplateTypes.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/service-form/template-type")
                        .then(response => {
                            context.state.dailyServiceFormTemplateTypes.data =
                                response.data;
                            context.state.dailyServiceFormTemplateTypes.loading = false;
                            resolve(
                                context.state.dailyServiceFormTemplateTypes.data
                            );
                        })
                        .catch(error => {
                            context.state.dailyServiceFormTemplateTypes.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.dailyServiceFormTemplateTypes.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(
                            context.state.dailyServiceFormTemplateTypes.data
                        );
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        serviceFormTypes: (context, company) => {
            if (context.state.serviceFormTypes[company] == undefined) {
                const obj = {};
                obj[company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.serviceFormTypes = Object.assign(
                    {},
                    context.state.serviceFormTypes,
                    obj
                );
            }
            if (
                !context.state.serviceFormTypes[company].loading &&
                context.state.serviceFormTypes[company].data.length < 1
            ) {
                context.state.serviceFormTypes[company].loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/" + company + "/service-form/type")
                        .then(response => {
                            context.state.serviceFormTypes[company].data =
                                response.data;
                            context.state.serviceFormTypes[
                                company
                            ].loading = false;
                            resolve(
                                context.state.serviceFormTypes[company].data
                            );
                        })
                        .catch(error => {
                            context.state.serviceFormTypes[company].error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.serviceFormTypes[
                                company
                            ].loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.serviceFormTypes[company].data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        taskTemplateTypes: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.taskTemplateTypes.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        serviceFormFrequencies: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.serviceFormFrequencies.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        vacationTypes: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.vacationTypes.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        weekDays: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.weekDays.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        colors: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.colors.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        bookingTypes: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.bookingTypes.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        operators: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.operators.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        absenceClassifications: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.absenceClassifications.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        resourceTypes: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.resourceTypes.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        actions: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.actions.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        serviceFormAvailabilities: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.serviceFormAvailabilities.data);
                },
                error => {
                    reject(error);
                }
            );
        },
        serviceFormControls: context => {
            if (!context.state.serviceFormControls.loading) {
                context.state.serviceFormControls.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/service-form/control")
                        .then(response => {
                            context.state.serviceFormControls.data =
                                response.data;
                            context.state.serviceFormControls.loading = false;
                            resolve(context.state.serviceFormControls.data);
                        })
                        .catch(error => {
                            context.state.serviceFormControls.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.serviceFormControls.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.serviceFormControls.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        stockMovementTypes: context => {
            if (
                !context.state.stockMovementTypes.loading &&
                context.state.stockMovementTypes.data.length < 1
            ) {
                context.state.stockMovementTypes.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/stock-movement-type")
                        .then(response => {
                            context.state.stockMovementTypes.data =
                                response.data;
                            context.state.stockMovementTypes.loading = false;
                            resolve(context.state.stockMovementTypes.data);
                        })
                        .catch(error => {
                            context.state.stockMovementTypes.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.stockMovementTypes.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.stockMovementTypes.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        countries: context => {
            if (
                !context.state.countries.loading &&
                context.state.countries.data.length < 1
            ) {
                context.state.countries.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/country")
                        .then(response => {
                            context.state.countries.data = response.data;
                            context.state.countries.loading = false;
                            resolve(context.state.countries.data);
                        })
                        .catch(error => {
                            context.state.countries.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.countries.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.countries.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        currencies: context => {
            if (
                !context.state.currencies.loading &&
                context.state.currencies.data.length < 1
            ) {
                context.state.currencies.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/currency")
                        .then(response => {
                            context.state.currencies.data = response.data;
                            context.state.currencies.loading = false;
                            resolve(context.state.currencies.data);
                        })
                        .catch(error => {
                            context.state.currencies.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.currencies.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.currencies.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        companies: context => {
            if (
                !context.state.companies.loading &&
                context.state.companies.data.length < 1
            ) {
                context.state.companies.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/company/user_role")
                        .then(response => {
                            context.state.companies.data = response.data;
                            context.state.companies.loading = false;
                            resolve(context.state.companies.data);
                        })
                        .catch(error => {
                            context.state.companies.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.companies.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.companies.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        departments: (context, company) => {
            if (context.state.departments[company] == undefined) {
                const obj = {};
                obj[company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.departments = Object.assign(
                    {},
                    context.state.departments,
                    obj
                );
            }
            if (
                !context.state.departments[company].loading &&
                context.state.departments[company].data.length < 1
            ) {
                context.state.departments[company].loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/" + company + "/department")
                        .then(response => {
                            context.state.departments[company].data =
                                response.data;
                            context.state.departments[company].loading = false;
                            resolve(context.state.departments[company].data);
                        })
                        .catch(error => {
                            context.state.departments[company].error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.departments[company].loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.departments[company].data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        charge_types: (context, company) => {
            if (context.state.charge_types[company] == undefined) {
                const obj = {};
                obj[company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.charge_types = Object.assign(
                    {},
                    context.state.charge_types,
                    obj
                );
            }
            if (
                !context.state.charge_types[company].loading &&
                context.state.charge_types[company].data.length < 1
            ) {
                context.state.charge_types[company].loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/" + company + "/estimate/charge_type")
                        .then(response => {
                            context.state.charge_types[company].data =
                                response.data;
                            context.state.charge_types[company].loading = false;
                            resolve(context.state.charge_types[company].data);
                        })
                        .catch(error => {
                            context.state.charge_types[company].error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.charge_types[company].loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.charge_types[company].data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        estimate_products: (context, payload) => {
            if (context.state.products[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.products = Object.assign(
                    {},
                    context.state.products,
                    obj
                );
            }

            context.state.products[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/estimate/" +
                            payload.estimate +
                            "/product"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.products[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.products[payload.company].data,
                                val
                            );
                        });
                        context.state.products[payload.company].loading = false;
                        resolve(context.state.products[payload.company].data);
                    })
                    .catch(error => {
                        context.state.products[payload.company].error =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.products[payload.company].loading = false;
                        reject(error);
                    });
            });
        },
        supplier_request_products: (context, payload) => {
            if (context.state.products[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.products = Object.assign(
                    {},
                    context.state.products,
                    obj
                );
            }
            context.state.products[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/supplier_request/" +
                            payload.supplier_request +
                            "/product"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.products[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.products[payload.company].data,
                                val
                            );
                        });
                        context.state.products[payload.company].loading = false;
                        resolve(context.state.products[payload.company].data);
                    })
                    .catch(error => {
                        context.state.products[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.products[payload.company].loading = false;
                        reject(error);
                    });
            });
        },
        expense_types: context => {
            if (
                !context.state.expense_types.loading &&
                context.state.expense_types.data.length < 1
            ) {
                context.state.expense_types.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/expense-type")
                        .then(response => {
                            context.state.expense_types.data = response.data;
                            context.state.expense_types.loading = false;
                            resolve(context.state.expense_types.data);
                        })
                        .catch(error => {
                            context.state.expense_types.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.expense_types.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.expense_types.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        blood_types: context => {
            if (
                !context.state.blood_types.loading &&
                context.state.blood_types.data.length < 1
            ) {
                context.state.blood_types.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/blood-type")
                        .then(response => {
                            context.state.blood_types.data = response.data;
                            context.state.blood_types.loading = false;
                            resolve(context.state.blood_types.data);
                        })
                        .catch(error => {
                            context.state.blood_types.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.blood_types.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.blood_types.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        it_equipment_event_types: context => {
            if (
                !context.state.it_equipment_event_types.loading &&
                context.state.it_equipment_event_types.data.length < 1
            ) {
                context.state.it_equipment_event_types.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/it_equipment_event_types")
                        .then(response => {
                            context.state.it_equipment_event_types.data =
                                response.data;
                            context.state.it_equipment_event_types.loading = false;
                            resolve(
                                context.state.it_equipment_event_types.data
                            );
                        })
                        .catch(error => {
                            context.state.it_equipment_event_types.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.it_equipment_event_types.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.it_equipment_event_types.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        it_equipment_accessory_types: context => {
            if (
                !context.state.it_equipment_accessory_types.loading &&
                context.state.it_equipment_accessory_types.data.length < 1
            ) {
                context.state.it_equipment_accessory_types.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/it_equipment_accessory_types")
                        .then(response => {
                            context.state.it_equipment_accessory_types.data =
                                response.data;
                            context.state.it_equipment_accessory_types.loading = false;
                            resolve(
                                context.state.it_equipment_accessory_types.data
                            );
                        })
                        .catch(error => {
                            context.state.it_equipment_accessory_types.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.it_equipment_accessory_types.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(
                            context.state.it_equipment_accessory_types.data
                        );
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        professional_developments_entities: context => {
            if (
                !context.state.professional_developments_entities.loading &&
                context.state.professional_developments_entities.data.length < 1
            ) {
                context.state.professional_developments_entities.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/professional-developments-entity")
                        .then(response => {
                            context.state.professional_developments_entities.data =
                                response.data;
                            context.state.professional_developments_entities.loading = false;
                            resolve(
                                context.state.professional_developments_entities
                                    .data
                            );
                        })
                        .catch(error => {
                            context.state.professional_developments_entities.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.professional_developments_entities.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(
                            context.state.professional_developments_entities
                                .data
                        );
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        doctors: context => {
            if (
                !context.state.doctors.loading &&
                context.state.doctors.data.length < 1
            ) {
                context.state.doctors.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/doctor")
                        .then(response => {
                            context.state.doctors.data = response.data;
                            context.state.doctors.loading = false;
                            resolve(context.state.doctors.data);
                        })
                        .catch(error => {
                            context.state.doctors.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.doctors.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.doctors.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        vehicle_insurance_entities: context => {
            if (
                !context.state.vehicle_insurance_entities.loading &&
                context.state.vehicle_insurance_entities.data.length < 1
            ) {
                context.state.vehicle_insurance_entities.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/vehicle_insurance_entity")
                        .then(response => {
                            context.state.vehicle_insurance_entities.data =
                                response.data;
                            context.state.vehicle_insurance_entities.loading = false;
                            resolve(
                                context.state.vehicle_insurance_entities.data
                            );
                        })
                        .catch(error => {
                            context.state.vehicle_insurance_entities.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.vehicle_insurance_entities.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.vehicle_insurance_entities.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        safety_next_appointment_months: context => {
            if (
                !context.state.safety_next_appointment_months.loading &&
                context.state.safety_next_appointment_months.data.length < 1
            ) {
                context.state.safety_next_appointment_months.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/safety-next-appointment-month")
                        .then(response => {
                            context.state.safety_next_appointment_months.data =
                                response.data;
                            context.state.safety_next_appointment_months.loading = false;
                            resolve(
                                context.state.safety_next_appointment_months
                                    .data
                            );
                        })
                        .catch(error => {
                            context.state.safety_next_appointment_months.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.safety_next_appointment_months.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(
                            context.state.safety_next_appointment_months.data
                        );
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        expense_cost_centers: (context, payload) => {
            if (context.state.cost_centers[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.cost_centers = Object.assign(
                    {},
                    context.state.cost_centers,
                    obj
                );
            }

            context.state.cost_centers[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/expense/" +
                            payload.expense +
                            "/cost-center"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;

                            if (
                                context.state.cost_centers[v.company_id] ==
                                undefined
                            ) {
                                const obj_t = {};
                                obj_t[v.company_id] = {
                                    data: [],
                                    loading: false,
                                    error: null
                                };
                                context.state.cost_centers = Object.assign(
                                    {},
                                    context.state.cost_centers,
                                    obj_t
                                );
                            }

                            context.state.cost_centers[
                                v.company_id
                            ].data = Object.assign(
                                {},
                                context.state.cost_centers[v.company_id].data,
                                val
                            );
                        });
                        context.state.cost_centers[
                            payload.company
                        ].loading = false;
                        resolve(
                            context.state.cost_centers[payload.company].data
                        );
                    })
                    .catch(error => {
                        context.state.cost_centers[payload.company].error =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.cost_centers[
                            payload.company
                        ].loading = false;
                        reject(error);
                    });
            });
        },
        expense_suppliers: (context, payload) => {
            if (context.state.suppliers[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.suppliers = Object.assign(
                    {},
                    context.state.suppliers,
                    obj
                );
            }

            context.state.suppliers[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/expense/" +
                            payload.expense +
                            "/supplier"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;

                            if (
                                context.state.suppliers[v.company_id] ==
                                undefined
                            ) {
                                const obj_t = {};
                                obj_t[v.company_id] = {
                                    data: [],
                                    loading: false,
                                    error: null
                                };
                                context.state.suppliers = Object.assign(
                                    {},
                                    context.state.suppliers,
                                    obj_t
                                );
                            }

                            context.state.suppliers[
                                v.company_id
                            ].data = Object.assign(
                                {},
                                context.state.suppliers[v.company_id].data,
                                val
                            );
                        });
                        context.state.suppliers[
                            payload.company
                        ].loading = false;
                        resolve(context.state.suppliers[payload.company].data);
                    })
                    .catch(error => {
                        context.state.suppliers[payload.company].error =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.suppliers[
                            payload.company
                        ].loading = false;
                        reject(error);
                    });
            });
        },
        component_access_levels: (context, payload) => {
            if (context.state.access_levels[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    access_levels: [],
                    loading: false,
                    error: null
                };
                context.state.access_levels = Object.assign(
                    {},
                    context.state.access_levels,
                    obj
                );
            }
            context.state.access_levels[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/component/" +
                            payload.component +
                            "/access_levels"
                    )
                    .then(response => {
                        context.state.access_levels[
                            payload.company
                        ].access_levels = response.data;
                        context.state.access_levels[
                            payload.company
                        ].loading = false;
                        resolve(
                            context.state.access_levels[payload.company]
                                .access_levels
                        );
                    })
                    .catch(error => {
                        context.state.access_levels[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.access_levels[
                            payload.company
                        ].loading = false;
                        reject(error);
                    });
            });
        },
        weekly_planning_employees: (context, payload) => {
            if (context.state.employees[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.employees = Object.assign(
                    {},
                    context.state.employees,
                    obj
                );
            }
            context.state.employees[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/weekly_planning/start/" +
                            payload.start_date +
                            "/end/" +
                            payload.end_date +
                            "/employees"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.employees[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.employees[payload.company].data,
                                val
                            );
                        });
                        context.state.employees[
                            payload.company
                        ].loading = false;
                        resolve(context.state.employees[payload.company].data);
                    })
                    .catch(error => {
                        context.state.employees[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.employees[
                            payload.company
                        ].loading = false;
                        reject(error);
                    });
            });
        },
        weekly_planning_vehicles: (context, payload) => {
            if (context.state.vehicles[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.vehicles = Object.assign(
                    {},
                    context.state.vehicles,
                    obj
                );
            }
            context.state.vehicles[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/weekly_planning/start/" +
                            payload.start_date +
                            "/end/" +
                            payload.end_date +
                            "/vehicles"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.vehicles[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.vehicles[payload.company].data,
                                val
                            );
                        });
                        context.state.vehicles[payload.company].loading = false;
                        resolve(context.state.vehicles[payload.company].data);
                    })
                    .catch(error => {
                        context.state.vehicles[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.vehicles[payload.company].loading = false;
                        reject(error);
                    });
            });
        },
        weekly_planning_equipments: (context, payload) => {
            if (context.state.equipments[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.equipments = Object.assign(
                    {},
                    context.state.equipments,
                    obj
                );
            }
            context.state.equipments[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/weekly_planning/start/" +
                            payload.start_date +
                            "/end/" +
                            payload.end_date +
                            "/equipments"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.equipments[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.equipments[payload.company].data,
                                val
                            );
                        });
                        context.state.equipments[
                            payload.company
                        ].loading = false;
                        resolve(context.state.equipments[payload.company].data);
                    })
                    .catch(error => {
                        context.state.equipments[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.equipments[
                            payload.company
                        ].loading = false;
                        reject(error);
                    });
            });
        },
        frequency_types: context => {
            if (
                !context.state.frequency_types.loading &&
                context.state.frequency_types.data.length < 1
            ) {
                context.state.frequency_types.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/production_frequency_types")
                        .then(response => {
                            context.state.frequency_types.data = response.data;
                            context.state.frequency_types.loading = false;
                            resolve(context.state.frequency_types.data);
                        })
                        .catch(error => {
                            context.state.frequency_types.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.frequency_types.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.frequency_types.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        production_tasks: (context, payload) => {
            if (context.state.tasks[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.tasks = Object.assign(
                    {},
                    context.state.tasks,
                    obj
                );
            }
            context.state.tasks[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/task_list_management/" +
                            payload.header_id +
                            "/get_tasks"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.tasks[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.tasks[payload.company].data,
                                val
                            );
                        });
                        context.state.tasks[payload.company].loading = false;
                        resolve(context.state.tasks[payload.company].data);
                    })
                    .catch(error => {
                        context.state.tasks[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.tasks[payload.company].loading = false;
                        reject(error);
                    });
            });
        },
        production_task_products: (context, payload) => {
            if (context.state.products[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.products = Object.assign(
                    {},
                    context.state.products,
                    obj
                );
            }
            context.state.products[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/pending_task_list/" +
                            payload.header +
                            "/products"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.products[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.products[payload.company].data,
                                val
                            );
                        });
                        context.state.products[payload.company].loading = false;
                        resolve(context.state.products[payload.company].data);
                    })
                    .catch(error => {
                        context.state.products[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.products[payload.company].loading = false;
                        reject(error);
                    });
            });
        },
        pv10_countries: context => {
            if (
                !context.state.pv10_countries.loading &&
                context.state.pv10_countries.data.length < 1
            ) {
                context.state.pv10_countries.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/pv10_countries")
                        .then(response => {
                            context.state.pv10_countries.data = response.data;
                            context.state.pv10_countries.loading = false;
                            resolve(context.state.pv10_countries.data);
                        })
                        .catch(error => {
                            context.state.pv10_countries.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.pv10_countries.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.pv10_countries.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        pv10_currencies: context => {
            if (
                !context.state.pv10_currencies.loading &&
                context.state.pv10_currencies.data.length < 1
            ) {
                context.state.pv10_currencies.loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/pv10_currencies")
                        .then(response => {
                            context.state.pv10_currencies.data = response.data;
                            context.state.pv10_currencies.loading = false;
                            resolve(context.state.pv10_currencies.data);
                        })
                        .catch(error => {
                            context.state.pv10_currencies.error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.pv10_currencies.loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.pv10_currencies.data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        daily_service_form_employees: (context, payload) => {
            if (context.state.employees[payload.company] == undefined) {
                const obj = {};
                obj[payload.company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.employees = Object.assign(
                    {},
                    context.state.employees,
                    obj
                );
            }
            context.state.employees[payload.company].loading = true;
            return new Promise((resolve, reject) => {
                Api()
                    .get(
                        "/api/" +
                            payload.company +
                            "/ficha_diaria_servico/" +
                            payload.form_id +
                            "/employees"
                    )
                    .then(response => {
                        Vue._.forEach(response.data, v => {
                            const val = {};
                            val[v.id] = v;
                            context.state.employees[
                                payload.company
                            ].data = Object.assign(
                                {},
                                context.state.employees[payload.company].data,
                                val
                            );
                        });
                        context.state.employees[
                            payload.company
                        ].loading = false;
                        resolve(context.state.employees[payload.company].data);
                    })
                    .catch(error => {
                        context.state.employees[payload.company].loading =
                            error.response && error.response.status
                                ? error.response.status
                                : -1;
                        context.state.employees[
                            payload.company
                        ].loading = false;
                        reject(error);
                    });
            });
        },
        ivas: (context, company) => {
            if (context.state.ivas[company] == undefined) {
                const obj = {};
                obj[company] = {
                    data: [],
                    loading: false,
                    error: null
                };
                context.state.ivas = Object.assign({}, context.state.ivas, obj);
            }
            if (
                !context.state.ivas[company].loading &&
                context.state.ivas[company].data.length < 1
            ) {
                context.state.ivas[company].loading = true;
                return new Promise((resolve, reject) => {
                    Api()
                        .get("/api/" + company + "/iva")
                        .then(response => {
                            context.state.ivas[company].data = response.data;
                            context.state.ivas[company].loading = false;
                            resolve(context.state.ivas[company].data);
                        })
                        .catch(error => {
                            context.state.ivas[company].error =
                                error.response && error.response.status
                                    ? error.response.status
                                    : -1;
                            context.state.ivas[company].loading = false;
                            reject(error);
                        });
                });
            } else {
                return new Promise(
                    (resolve, reject) => {
                        resolve(context.state.ivas[company].data);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        },
        movementTypes: context => {
            return new Promise(
                (resolve, reject) => {
                    resolve(context.state.movementTypes.data);
                },
                error => {
                    reject(error);
                }
            );
        }
    }
};

export default app;



// WEBPACK FOOTER //
// ./resources/js/store/modules/app.js